import {
    NG_VALIDATORS,
    FormControl,
    ValidatorFn,
    Validator
} from '@angular/forms';
import { Directive } from '@angular/core';

@Directive({
    selector: '[datevalidator][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: DateValidator,
            multi: true
        }
    ]
})
export class DateValidator implements Validator {

    validator: ValidatorFn;

    constructor() {
        this.validator = this.dateValidator();
    }

    validate(c: FormControl) {
        return this.validator(c);
    }

    dateValidator(): ValidatorFn {
        return (c: FormControl) => {
            if (c.pristine) {
                return null;
            }
            if ((c.value !== undefined && c.value !== '' && c.value != null)) {

                var month = null;
                var day = null;
                var year = null;
                //var currentTaxYear = Number(new Date().getFullYear() - 1);
                if (c.value.toString().includes('/')) {
                    var res = c.value.toString().split("/");
                    if (res.length > 1) {
                        month = res[0];
                        day = res[1]
                        year = res[2];
                    }
                }
                else {
                    if (c.value.length == 8) {
                        month = c.value.substring(0, 2);
                        day = c.value.substring(2, 4);
                        year = c.value.substring(4, 8);
                    }
                }
                if (isNaN(month) || isNaN(day) || isNaN(year)) {
                    return { datevalidator: false };
                }
                month = Number(month);
                day = Number(day);
                year = Number(year);
                if (month < 1 || month > 12) { // check month range
                    return { datevalidator: false };
                }
                if (day < 1 || day > 31) {
                    return { datevalidator: false };
                }
                if ((month === 4 || month === 6 || month === 9 || month === 11) && day === 31) {
                    return { datevalidator: false };
                }
                if (month == 2) { // check for february 29th
                    var isleap = (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0));
                    if (day > 29 || (day === 29 && !isleap)) {
                        return { datevalidator: false };
                    }
                }
                // if (year !== currentTaxYear) {
                //     return { 'dateYearGreaterThanTaxYear': true };
                // }
            }
            return null;
        }
    }
}